/**
 * 獎品類型
 *
 * - 1: 寄送獎
 * - 2: 自製優惠卷
 * - 3: 上傳序號
 * - 4: 銘謝惠顧
 * - 5: 會員點數 - 固定
 * - 6: 購物金
 * - 7: 獎品代碼
 * - 8: Cyberbiz 動態序號
 * - 9: 會員點數 - 動態
 * - 10: 活動點數 - 動態計算
 * - 11: 活動點數 - 固定給予
 * - 12: Shopline 動態序號
 */

const GENERAL_PRIZE = 1;
const GENERAL_COUPON = 2;
const COUPON_CODE = 3;
const THANKYOU = 4;
const POINT = 5;
const CASH_VOUCHER = 6;
const PRIZE_CODE = 7;
const CYBERBIZ_COUPON = 8;
const MEMBERSHIP_DYNAMIC_POINT = 9;
const PROMO_DYNAMIC_POINT = 10;
const PROMO_FIXED_POINT = 11;
const SHOPLINE_COUPON_CODE = 12;

export const prizeTypes = {
    GENERAL_PRIZE,
    GENERAL_COUPON,
    COUPON_CODE,
    THANKYOU,
    POINT,
    CASH_VOUCHER,
    PRIZE_CODE,
    CYBERBIZ_COUPON,
    MEMBERSHIP_DYNAMIC_POINT,
    PROMO_DYNAMIC_POINT,
    PROMO_FIXED_POINT,
    SHOPLINE_COUPON_CODE
};

// 活動點數獎品
const promoPointPrizeTypes = new Set([
    prizeTypes.PROMO_DYNAMIC_POINT,
    prizeTypes.PROMO_FIXED_POINT
]);
export function isPromoPointPrizeType(prizeType) {
    return promoPointPrizeTypes.has(prizeType);
}

// 會員點數獎品（第三方點數平台）。得獎歸戶時會寫入累點交易紀錄。
const memberPointPrizeTypes = new Set([prizeTypes.POINT, prizeTypes.MEMBERSHIP_DYNAMIC_POINT]);
export function isMemberPointPrizeType(prizeType) {
    return memberPointPrizeTypes.has(prizeType);
}

/**
 * 活動是否設有會員點數獎品
 * @param   {object} prizes getPrizeList 回傳的獎品集合
 *                          { prizeInstant: [], prizeParticipant: [], prizeAdmin: [], prizeTask: { [uuid]: [] } }
 * @return  {boolean}
 */
export function hasMemberPointPrize(prizes = {}) {
    return Object.values(prizes)
        .flatMap(group => (Array.isArray(group) ? group : Object.values(group ?? {}).flat()))
        .some(({ type } = {}) => isMemberPointPrizeType(type));
}

// 得獎管理的每一項獎品得獎名單 table 欄位是否要顯示 歸戶狀態及歸戶按鈕
const carrierClaimPrizeTypes = new Set([
    prizeTypes.POINT,
    prizeTypes.CASH_VOUCHER,
    prizeTypes.PRIZE_CODE,
    prizeTypes.CYBERBIZ_COUPON,
    prizeTypes.MEMBERSHIP_DYNAMIC_POINT,
    prizeTypes.SHOPLINE_COUPON_CODE
]);
export function isCarrierClaimPrizeTypes(prizeType) {
    return carrierClaimPrizeTypes.has(prizeType);
}

// 得獎管理的每一項獎品得獎名單 table 欄位是否要顯示 coupon 序號
const couponPrizeTypes = new Set([prizeTypes.GENERAL_COUPON, prizeTypes.COUPON_CODE]);
export function isCouponPrizeTypes(prizeType) {
    return couponPrizeTypes.has(prizeType);
}

const allPrizeTypes = new Set([
    prizeTypes.GENERAL_PRIZE,
    prizeTypes.GENERAL_COUPON,
    prizeTypes.COUPON_CODE,
    prizeTypes.THANKYOU,
    prizeTypes.POINT,
    prizeTypes.CASH_VOUCHER,
    prizeTypes.PRIZE_CODE,
    prizeTypes.CYBERBIZ_COUPON,
    prizeTypes.MEMBERSHIP_DYNAMIC_POINT,
    prizeTypes.SHOPLINE_COUPON_CODE
]);
export function isAllPrizeTypes(prizeType) {
    return allPrizeTypes.has(prizeType);
}

// ticket [860rtg851]: 用在 【下載歸戶失敗名單】功能按鈕
const transactionStatusPrizeTypes = new Set([
    prizeTypes.POINT,
    prizeTypes.CASH_VOUCHER,
    prizeTypes.PRIZE_CODE,
    prizeTypes.CYBERBIZ_COUPON,
    prizeTypes.MEMBERSHIP_DYNAMIC_POINT,
    prizeTypes.SHOPLINE_COUPON_CODE
]);
export function haveToCheckTransactionStatusPrizeTypes(prizeType) {
    return transactionStatusPrizeTypes.has(prizeType);
}
